'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Collection_Header = require('./Collection_Header');

var _Collection_Header2 = _interopRequireDefault(_Collection_Header);

var _Collection_Icon_Wrapper = require('./Collection_Icon_Wrapper');

var _Collection_Icon_Wrapper2 = _interopRequireDefault(_Collection_Icon_Wrapper);

var _SvgIcon = require('./SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Collection = function (_React$Component) {
	_inherits(Collection, _React$Component);

	function Collection() {
		_classCallCheck(this, Collection);

		var _this = _possibleConstructorReturn(this, (Collection.__proto__ || Object.getPrototypeOf(Collection)).call(this));

		_this.loadMoreIcons = _this.loadMoreIcons.bind(_this);

		_this.state = {
			btnIsLoading: false
		};
		return _this;
	}

	_createClass(Collection, [{
		key: 'loadMoreIcons',
		value: function loadMoreIcons(collection, after) {
			this.setState({
				btnIsLoading: true
			});
			this.props.loadMore(collection, after);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props$collection = this.props.collection,
			    iconset_id = _props$collection.iconset_id,
			    identifier = _props$collection.identifier,
			    icons = _props$collection.icons,
			    name = _props$collection.name,
			    version = _props$collection.version,
			    author_name = _props$collection.author_name,
			    author_url = _props$collection.author_url,
			    license_name = _props$collection.license_name,
			    license_url = _props$collection.license_url,
			    internal_id = _props$collection.internal_id,
			    is_premium = _props$collection.is_premium,
			    type = _props$collection.type;


			var meta = {
				identifier: identifier,
				name: name,
				version: version,
				author_name: author_name,
				author_url: author_url,
				license_name: license_name,
				license_url: license_url,
				is_premium: is_premium,
				type: type
			};

			if (is_premium) {
				meta.prices = this.props.collection.prices;
			}

			var checkSelected = function checkSelected(internal_id) {
				return _this2.props.selected.some(function (el) {
					return el.internal_id === internal_id;
				});
			};
			var checkLocked = function checkLocked(internal_id) {
				return _this2.props.selected.some(function (el) {
					return el.internal_id === internal_id && iconPressConfig.lock == 1 && el.user_id !== iconPressConfig.user_id;
				});
			};

			// const iconObjectArr = Object.keys( icons );
			var iconObjectArr = [];

			if (icons.length || Object.keys(icons).length !== 0) {
				iconObjectArr = icons;
			}

			var loadMoreIconsButton = '';

			if (iconObjectArr.length < parseFloat(this.props.collection.icons_count)) {

				// Check if button is loading
				var btnText = iconPressConfig.translations.LOAD_MORE;
				if (Object.keys(this.props.isLoadingNewIcons).length !== 0 && this.props.isLoadingNewIcons[iconset_id] !== void 0 && this.props.isLoadingNewIcons[iconset_id]) {
					btnText = _react2.default.createElement(_SvgIcon2.default, { icon: 'spinner' });
				}

				var lastIconID = iconObjectArr.filter(function (el) {
					return el.is_last === true;
				}).slice(-1)[0].icon_id;

				loadMoreIconsButton = _react2.default.createElement(
					'button',
					{ className: 'ip-loadMoreIcons', onClick: function onClick(e) {
							_this2.loadMoreIcons(_this2.props.collection, lastIconID);
						} },
					' ',
					btnText
				);
			}

			return _react2.default.createElement(
				'div',
				{ className: 'ip-collectionWrapper collection-' + iconset_id },
				_react2.default.createElement(_Collection_Header2.default, {
					meta: meta,
					selected: this.props.selected,
					index: iconset_id
				}),
				_react2.default.createElement(
					'div',
					{ className: 'ip-collection' },
					_react2.default.createElement(_Collection_Icon_Wrapper2.default, {
						items: iconObjectArr,
						selected: this.props.selected,
						toggleSelected: this.props.toggleSelected
					}),
					loadMoreIconsButton
				)
			);
		}
	}]);

	return Collection;
}(_react2.default.Component);

exports.default = Collection;


//////////////////
// WEBPACK FOOTER
// ./src/components/Collection.js
// module id = 257
// module chunks = 0 1